import React from 'react';
import { Search, X } from 'lucide-react';
import styles from './ListingFilter.module.css';

const ListingFilter = ({
    searchPlaceholder = "Search items...",
    searchValue = "",
    onSearchChange,
    filters = [],
    activeFilters = {},
    onFilterChange,
    onClearFilters,
    className = ""
}) => {
    return (
        <div className={`${styles.filterContainer} ${className} `}>
            <div className={styles.searchWrapper}>
                <span className={styles.searchIcon}>
                    <Search size={18} />
                </span>
                <input
                    type="text"
                    className={styles.searchInput}
                    placeholder={searchPlaceholder}
                    value={searchValue}
                    onChange={(e) => onSearchChange?.(e.target.value)}
                />
                {searchValue && (
                    <button
                        className={styles.clearSearch}
                        onClick={() => onSearchChange?.('')}
                        title="Clear search"
                    >
                        <X size={14} />
                    </button>
                )}
            </div>

            <div className={styles.filtersGroup}>
                {filters.map((filter) => (
                    <div key={filter.name} className={styles.filterWrapper}>
                        <select
                            className={styles.filterSelect}
                            value={activeFilters[filter.name] || ''}
                            onChange={(e) => onFilterChange?.(filter.name, e.target.value)}
                        >
                            <option value="">{filter.label}</option>
                            {filter.options.map((opt) => (
                                <option key={opt.value} value={opt.value}>
                                    {opt.label}
                                </option>
                            ))}
                        </select>
                    </div>
                ))}

                {Object.keys(activeFilters).some(k => activeFilters[k]) && onClearFilters && (
                    <button className={styles.clearAll} onClick={onClearFilters}>
                        Clear Filters
                    </button>
                )}
            </div>
        </div>
    );
};

export default ListingFilter;
